import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 1 }

import ComEditButton from '@/components/common/buttons/ComEditButton.vue';
import ComCancelIconButton from '@/components/common/buttons/ComCancelIconButton.vue';
import ComSaveButton from '@/components/common/buttons/ComSaveButton.vue';
import { HuonekorttiSahkoluokka } from '@/api/models/huonekortti-sahkoluokka';
import { Loading, Check, CircleClose } from '@element-plus/icons-vue';
import ToimintaAika from '@/types/ToimintaAikaEnum';
import { useHuonekorttiMuokkausComponent } from './huonekorttiMuokkaus';


export default /*@__PURE__*/_defineComponent({
  __name: 'ComHuonekorttiMuokkausTable',
  setup(__props) {

const {
    huonekortit,
    editedHuonekortti,
    editedId,
    loading,
    updateSuccess,
    updateErrors,
    muokkaaHuonekorttia,
    peruutaMuokkaus,
    tallennaMuokkaus
} = useHuonekorttiMuokkausComponent()
const sahkoluokat = Object.values(HuonekorttiSahkoluokka)
const toimintaAika = ToimintaAika

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createBlock(_component_el_table, { data: _unref(huonekortit) }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table_column, {
        prop: "tilanimike.nimi",
        label: "Tilanimike",
        width: "200"
      }),
      _createVNode(_component_el_table_column, {
        prop: "toiminta",
        label: "Täsmennys",
        width: "200"
      }),
      _createVNode(_component_el_table_column, {
        label: "Henkilömäärä norm.",
        width: "160"
      }, {
        default: _withCtx((scope) => [
          (_unref(editedId) == scope.row.id && _unref(editedHuonekortti))
            ? (_openBlock(), _createBlock(_component_el_input_number, {
                key: 0,
                modelValue: _unref(editedHuonekortti).henkilomaaraNorm,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(editedHuonekortti).henkilomaaraNorm) = $event)),
                min: 0,
                size: "small",
                style: {"width":"100%"}
              }, null, 8, ["modelValue"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(scope.row.henkilomaaraNorm), 1))
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "Henkilömäärä max",
        width: "160"
      }, {
        default: _withCtx((scope) => [
          (_unref(editedId) == scope.row.id && _unref(editedHuonekortti))
            ? (_openBlock(), _createBlock(_component_el_input_number, {
                key: 0,
                modelValue: _unref(editedHuonekortti).henkilomaaraMax,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(editedHuonekortti).henkilomaaraMax) = $event)),
                min: 0,
                size: "small",
                style: {"width":"100%"}
              }, null, 8, ["modelValue"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(scope.row.henkilomaaraMax), 1))
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "Toiminta-aika",
        width: "150"
      }, {
        default: _withCtx((scope) => [
          (_unref(editedId) == scope.row.id && _unref(editedHuonekortti))
            ? (_openBlock(), _createBlock(_component_el_select, {
                key: 0,
                modelValue: _unref(editedHuonekortti).toimintaAika,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(editedHuonekortti).toimintaAika) = $event)),
                "allow-create": "",
                filterable: "",
                placeholder: "Valitse tai kirjoita",
                size: "small",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toimintaAika), (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item,
                      label: item,
                      value: item
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(scope.row.toimintaAika), 1))
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "Sähköluokka",
        width: "120"
      }, {
        default: _withCtx((scope) => [
          (_unref(editedId) == scope.row.id && _unref(editedHuonekortti))
            ? (_openBlock(), _createBlock(_component_el_select, {
                key: 0,
                modelValue: _unref(editedHuonekortti).sahkoluokka,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(editedHuonekortti).sahkoluokka) = $event)),
                placeholder: "Valitse",
                size: "small",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sahkoluokat), (luokka) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: luokka,
                      label: luokka,
                      value: luokka
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(scope.row.sahkoluokka), 1))
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "Muokkaa",
        width: "100px"
      }, {
        default: _withCtx((scope) => [
          (_unref(loading) && !_unref(updateSuccess).includes(scope.row.id) && !_unref(updateErrors).includes(scope.row.id))
            ? (_openBlock(), _createBlock(_component_el_icon, {
                key: 0,
                class: "is-loading"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Loading))
                ]),
                _: 1
              }))
            : (_unref(updateErrors).includes(scope.row.id))
              ? (_openBlock(), _createBlock(_component_el_icon, {
                  key: 1,
                  style: {"color":"var(--el-color-danger)"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(CircleClose))
                  ]),
                  _: 1
                }))
              : (_unref(updateSuccess).includes(scope.row.id))
                ? (_openBlock(), _createBlock(_component_el_icon, {
                    key: 2,
                    style: {"color":"var(--el-color-success)"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Check))
                    ]),
                    _: 1
                  }))
                : (_unref(editedId) == scope.row.id)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createVNode(ComCancelIconButton, {
                        size: "small",
                        onClick: _unref(peruutaMuokkaus)
                      }, null, 8, ["onClick"]),
                      _createVNode(ComSaveButton, {
                        size: "small",
                        onClick: _unref(tallennaMuokkaus)
                      }, null, 8, ["onClick"])
                    ], 64))
                  : (_openBlock(), _createBlock(ComEditButton, {
                      key: 4,
                      type: "primary",
                      size: "small",
                      onClick: ($event: any) => (_unref(muokkaaHuonekorttia)(scope.row))
                    }, null, 8, ["onClick"]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})